import {
  Breadcrumbs,
  Grid,
  Link,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import Styles from "../../Styles/main.module.css";
import TrackerTable from "./TrackerTable";
import logo from "../../../../images/Group 1000000833.png";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { ls } from "../../../../variables";
import { useStateValue } from "../../../../Hooks/stateProvider";
import Loader from "../../../../Loader/Loader";
import { encrypt } from "../../../../utils/cipher";
import FilterList from "../../../../components/FilterList";
import { Box } from "@mui/system";
import { previewValidators } from "../../../../utils/validators";
import SelectComponent from "../../../../components/SelectComponent";
import { errorHandler } from "../../../../utils/errorHandling";
const TrackerPage = (props) => {

  const navigate = useNavigate();
  const [{ pageLoading, fy_year, quarter, half_year, CMMType, pmsOpenNestedList, setFilter }, dispatch] = useStateValue();
  // const [selectedCompliance, setSelectedCompliance] = useState("");
  const [selectedQuarter, setSelectedQuarter] = useState(quarter);
  // const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedFinancialYear, setSelectedFinancialYear] = useState(fy_year);
  // const [selectedGuidanceType, setSelectedGuidanceType] = useState("");
  const [previewState, setPreviewState] = useState(true);
  // const [apply, setApply] = useState(false);
  const [rows, setRows] = useState([]);
  const [allRows, setAllRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openselectBox, setOpenselectBox] = useState(false);
  const [openNestedList, setOpenNestedList] = useState({
    "localCMMTypeData": [CMMType],
    "localRemarksData": [],
    "localStatusData": ["open"],
    "localGuidanceData": []
  })
  const [filteredRows, setFilteredRows] = useState(rows);
  const [searchQuery, setSearchQuery] = useState("");
  const [dataFetchFlag, setDataFetchFlag] = useState(false);

  const handlePreviewState = (isAllSelected) => {
    if (isAllSelected) setPreviewState(true);
    else setPreviewState(false);
  };

  let type
  const pmsName = ls.get("pmsName");
  const userType = ls.get("userType");
  const location = useLocation();
  if (location.pathname == '/app/cmmTracker') {
    type = 'cmm'
  } 
  let trackerPayload;
  if (type == 'cmm') {
    trackerPayload = {
      "moduleType": type.toUpperCase(),
      "fy_year": selectedFinancialYear,
      "quarter": selectedQuarter,
      "pmsName": pmsName,
      "authToken": ls.get("authToken"),
      "refreshtoken": ls.get("refreshToken"),
      "userType": "PMS"
    }
  } 

  const getFilteredData = (element) => {
    if (type == 'cmm') {
      setFilteredRows(allRows.filter((val) => {

        if (openNestedList["localRemarksData"].length == 0 && openNestedList["localStatusData"].length == 0 && pmsOpenNestedList["localRemarksData"].length == 0 && pmsOpenNestedList["localStatusData"].length == 0) {
          return openNestedList["localCMMTypeData"]?.includes(val.cmm_type)
        }

        if(element){
          const hasRemarks = element["localRemarksData"].length !== 0;
          const hasStatus = element["localStatusData"].length !== 0;
          return (
            element["localCMMTypeData"]?.includes(val.cmm_type) &&
            (!hasRemarks || element["localRemarksData"]?.includes(val.compliance_status)) &&
            (!hasStatus || element["localStatusData"]?.includes(val.status))
          );
        }
        else if (setFilter && !element) {

          const hasRemarks = openNestedList["localRemarksData"].length !== 0;
          const hasStatus = openNestedList["localStatusData"].length !== 0;
  
          return (
            openNestedList["localCMMTypeData"]?.includes(val.cmm_type) &&
            (!hasRemarks || openNestedList["localRemarksData"]?.includes(val.compliance_status)) &&
            (!hasStatus || openNestedList["localStatusData"]?.includes(val.status))
          );
        } else {
  
          const hasRemarks = pmsOpenNestedList["localRemarksData"].length !== 0;
          const hasStatus = pmsOpenNestedList["localStatusData"].length !== 0;
  
          return (
            pmsOpenNestedList["localCMMTypeData"]?.includes(val.cmm_type) &&
            (!hasRemarks || pmsOpenNestedList["localRemarksData"]?.includes(val.compliance_status)) &&
            (!hasStatus || pmsOpenNestedList["localStatusData"]?.includes(val.status))
          );
        }
      }));
    } else {
      setFilteredRows(allRows.filter((val) => {

        if (openNestedList["localRemarksData"].length == 0 && openNestedList["localStatusData"].length == 0 && pmsOpenNestedList["localRemarksData"].length == 0 && pmsOpenNestedList["localStatusData"].length == 0) {
          return true;
        }
        if(element){
          const hasRemarks = element["localRemarksData"].length !== 0;
          const hasStatus = element["localStatusData"].length !== 0;
          return (
            (!hasRemarks || element["localRemarksData"]?.includes(val.compliance_status)) &&
            (!hasStatus || element["localStatusData"]?.includes(val.status))
          );
        }
        else if (setFilter && !element) {

          const hasRemarks = openNestedList["localRemarksData"].length !== 0;
          const hasStatus = openNestedList["localStatusData"].length !== 0;
  
          return (
            (!hasRemarks || openNestedList["localRemarksData"]?.includes(val.compliance_status)) &&
            (!hasStatus || openNestedList["localStatusData"]?.includes(val.status))
          );
        } else {
  
          const hasRemarks = pmsOpenNestedList["localRemarksData"].length !== 0;
          const hasStatus = pmsOpenNestedList["localStatusData"].length !== 0;
  
          return (
            (!hasRemarks || pmsOpenNestedList["localRemarksData"]?.includes(val.compliance_status)) &&
            (!hasStatus || pmsOpenNestedList["localStatusData"]?.includes(val.status))
          );
        }
      }));

    }
  }
  const trackerPageFetch = async () => {
    // console.log("trackerPayload", trackerPayload);

    try {
      if (!handlePreviewClick()) {
        return
      }

      setRows([])
      dispatch({ type: "SHOW_LOADER" });
      const encryptedPayload = await encrypt(trackerPayload)
      const response = await axios.post('/api/pms/trackerPageFetchAPI', { payload: encryptedPayload })

      if (type == 'cmm') {
        dispatch({
          type: "CMMTrackerData",
          CMMTrackerData: {
            fy_year: selectedFinancialYear,
            quarter: selectedQuarter,

          }
        })
      }

      if (!response.data.data) {
        setLoading(true);

        return;
      }

      // setPreviewClicked(true);
      const newRows = response.data.data.map((val, id) => {
        if (type == 'cmm') {
          return {
            index:val.id,
            id: val.cmm_id,
            particulars: val.particulars,
            status: val.cmm_status,
            compliance_status: val.compliance_status,
            compliance_percentage: val.compliance_percentage,
            remarks: val.cmm_remarks,
            cmm_type: val.cmm_type
            

          }
        }
        // else {
        //   return {

        //     id: val.hytr_id,
        //     status: val.hytr_status,
        //     compliance_status: val.compliance_status,
        //     compliance_percentage: val.compliance_percentage,
        //     remarks: val.hytr_remarks,

        //   }
        // }
      })
      dispatch({ type: "HIDE_LOADER" });
      setLoading(false);
      setAllRows(newRows)
      if (type == 'cmm') {
        setRows(newRows.filter((val) => {
          return val.cmm_type == CMMType
        }))
        setFilteredRows(newRows.filter((val) => {

          if (openNestedList["localRemarksData"].length == 0 && openNestedList["localStatusData"].length == 0 && pmsOpenNestedList["localRemarksData"].length == 0 && pmsOpenNestedList["localStatusData"].length == 0) {
            return openNestedList["localCMMTypeData"]?.includes(val.cmm_type)
          }

          if (setFilter) {

            const hasRemarks = openNestedList["localRemarksData"].length !== 0;
            const hasStatus = openNestedList["localStatusData"].length !== 0;
    
            return (
              openNestedList["localCMMTypeData"]?.includes(val.cmm_type) &&
              (!hasRemarks || openNestedList["localRemarksData"]?.includes(val.compliance_status)) &&
              (!hasStatus || openNestedList["localStatusData"]?.includes(val.status))
            );
          } else {
    
            const hasRemarks = pmsOpenNestedList["localRemarksData"].length !== 0;
            const hasStatus = pmsOpenNestedList["localStatusData"].length !== 0;
    
            return (
              pmsOpenNestedList["localCMMTypeData"]?.includes(val.cmm_type) &&
              (!hasRemarks || pmsOpenNestedList["localRemarksData"]?.includes(val.compliance_status)) &&
              (!hasStatus || pmsOpenNestedList["localStatusData"]?.includes(val.status))
            );
          }
        }));
      } else {
        setRows(newRows);
        setFilteredRows(newRows.filter((val) => {

          if (openNestedList["localRemarksData"].length == 0 && openNestedList["localStatusData"].length == 0 && pmsOpenNestedList["localRemarksData"].length == 0 && pmsOpenNestedList["localStatusData"].length == 0) {
            return true;
          }
          // console.log("the setfilter",setFilter);
          if (setFilter) {

            const hasRemarks = openNestedList["localRemarksData"].length !== 0;
            const hasStatus = openNestedList["localStatusData"].length !== 0;
    
            return (
              (!hasRemarks || openNestedList["localRemarksData"]?.includes(val.compliance_status)) &&
              (!hasStatus || openNestedList["localStatusData"]?.includes(val.status))
            );
          } else {
    
            const hasRemarks = pmsOpenNestedList["localRemarksData"].length !== 0;
            const hasStatus = pmsOpenNestedList["localStatusData"].length !== 0;
    
            return (
              (!hasRemarks || pmsOpenNestedList["localRemarksData"]?.includes(val.compliance_status)) &&
              (!hasStatus || pmsOpenNestedList["localStatusData"]?.includes(val.status))
            );
          }
        }));

      }
      setDataFetchFlag(true);
    }
    catch (err) {
      dispatch({ type: "HIDE_LOADER" });
      setLoading(false);
      errorHandler(err, navigate)
    }
  }
  const handlePreviewClick = () => {

    if (props.type === "cmm") {
      return previewValidators(selectedFinancialYear, selectedQuarter, false, "", dispatch, pmsName)
    } 
  };


  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    const filteredData = rows.filter((row) => {
      const { particulars, status, ...rest } = row;
      return Object.values({ particulars,status }).some((val) =>
        val?.toString().toLowerCase().includes(query.toLowerCase())
      );
    });
    setFilteredRows(filteredData);
  };

  useEffect(() => {

    if (fy_year != "" && (quarter != "") && openNestedList["localCMMTypeData"].length != 0) {
      trackerPageFetch();
    }
  }, [])

  
  useEffect(() => {
    // setRows([]);
    dispatch({ type: "fy_year", fy_year: selectedFinancialYear });
    dispatch({ type: "quarter", quarter: selectedQuarter });

  }, [selectedFinancialYear, selectedQuarter]);


  // useEffect(() => {
  //   dispatch({ type: "CMMTypeData", CMMType: openNestedList['localCMMTypeData'][0] })
  // }, [openNestedList['localCMMTypeData'][0]])

  return (
    <>
      <div className={Styles.FullBody}>
        <div className={Styles.navBody}>
          <Breadcrumbs className={Styles.historyNav} aria-label="breadcrumb">
            <Link
              underline="hover"
              color="inherit"
              onClick={() => navigate("/app/welcome")}
            >
              Welcome
            </Link>
            <Link
              underline="hover"
              color="inherit"
              onClick={props.type === "cmm" ? () => navigate("/app/cmmLayout") : () => navigate("/app/hytrLayout")}
            >
              {props.type === "cmm" ? "CMM" : ""}
            </Link>
            <Link
              underline="hover"
              color="inherit"
            >
              {" Tracker"}
            </Link>
          </Breadcrumbs>
          {allRows.length > 0 && <TextField
            style={{
              height: "2rem",
              width: "clamp(10rem,20vw,30rem)",
            }}
            // id="outlined-basic"
            variant="outlined"
            placeholder="Search Table"
            // className="textfield_input"
            value={searchQuery}
            onChange={handleSearch}
          />}
        </div>
        <div className={Styles.HeaderBody}>
          <div>
            <Grid container spacing={2} display="flex">
              <Grid item
                xs={12}
                sm={12}
                md={8}
                lg={9}>
                <SelectComponent
                  selectedFinancialYear={selectedFinancialYear}
                  setSelectedFinancialYear={setSelectedFinancialYear}
                  selectedQuarter={selectedQuarter}
                  setSelectedQuarter={setSelectedQuarter}
                   />
              </Grid>




              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                lg={3}
                className={Styles.dataFormButtonTracker}
                style={{
                  display: "flex",
                  alignItems: "end",
                  justifyContent: "flex-end",
                }}
              >
                <div>
                  <button className={Styles.Preview} onClick={trackerPageFetch}>
                    APPLY
                  </button>
                  {allRows.length != 0 && <button className={Styles.Preview} style={{ marginLeft: "1rem" }} onClick={(e) => {
                    e.stopPropagation()
                    setOpenselectBox(true)
                  }}>
                    FILTER
                  </button>}
                  {openselectBox && (
                    <Box
                      sx={{
                        bgcolor: "background.paper",
                        width: { xs: "35%", md: "30%", lg: "28%" },
                        position: "absolute",
                        right: { xs: "1.2rem", md: "2rem" },
                        backgroundColor: "#ffffff",
                        zIndex: "100",
                        boxShadow: 6,
                        marginTop: "0.5rem",
                        borderRadius: "1rem",
                      }
                      }
                    >

                      <FilterList handleOpen={setOpenselectBox} open={openselectBox} openNestedList={openNestedList} setOpenNestedList={setOpenNestedList} moduleType={type} fetchData={getFilteredData}/>
                    </Box>
                  )
                  }
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
        <div className={Styles.tableBody} style={{ position: "relative" }}>
          {!dataFetchFlag && <Loader />}
          {dataFetchFlag && <TrackerTable rows={filteredRows} previewFunc={handlePreviewState} type={type} fy_year={selectedFinancialYear} quarter={selectedQuarter} />}
          {(pageLoading == false || pageLoading == undefined) && !dataFetchFlag &&
            (
              <img
                className="image"
                src={logo}
                alt="MainImage"
              />
            )}

        </div>
      </div>
    </>
  );
};

export default TrackerPage;
